/* =========================================================
   LUMINIAIRE FRANCE — PRODUCT CARD
   Panier • Variantes • Quantité • Mini-panier • Sticky mobile
   ========================================================= */

(function () {
  'use strict';

  function initProductCart(card) {
    if (!card || card.dataset.lfCartInit === '1') return;

    const pid = card.id.replace('lfProductCard-', '');

    /* =====================================================
       ÉLÉMENTS PRINCIPAUX
       ===================================================== */

    const form = card.querySelector('.lf-product-buy-form');
    const addButton = card.querySelector('#lfAddButton-' + pid);
    const buyButton = card.querySelector('#lfBuyNow-' + pid);

    const variantInput =
      card.querySelector('#lfVariantId-' + pid);

    const quantityInput =
      card.querySelector('#lfQuantity-' + pid);

    const variantSelect =
      card.querySelector('#lfVariant-' + pid);

    const price =
      card.querySelector('#lfPrice-' + pid);

    const addPrice =
      card.querySelector('#lfAddPrice-' + pid);

    const stock =
      card.querySelector('#lfStock-' + pid);

    const mainImage =
      card.querySelector('.lf-main-product-image');

    /* =====================================================
       STICKY MOBILE
       ===================================================== */

    const mobileStickyBar =
      document.getElementById(
        'lfMobileStickyBar-' + pid
      );

    const mobileStickyAdd =
      mobileStickyBar
        ? mobileStickyBar.querySelector(
            '[data-lf-sticky-add]'
          ) ||
          mobileStickyBar.querySelector(
            '#lfMobileStickyAdd-' + pid
          )
        : document.getElementById(
            'lfMobileStickyAdd-' + pid
          );

    const mobileStickyPrice =
      document.getElementById(
        'lfMobileStickyPrice-' + pid
      );

    const mobileStickyQuantity =
      mobileStickyBar
        ? mobileStickyBar.querySelector(
            '[data-lf-sticky-quantity]'
          )
        : null;

    const mobileStickyVariant =
      mobileStickyBar
        ? mobileStickyBar.querySelector(
            '#lfMobileStickyVariant-' + pid
          ) ||
          mobileStickyBar.querySelector(
            '.lf-mobile-sticky-variant-select'
          )
        : null;

    /* =====================================================
       MINI PANIER
       ===================================================== */

    const mini =
      document.getElementById(
        'lfMobileMiniCart-' + pid
      );

    if (
      !form ||
      !addButton ||
      !variantInput ||
      !quantityInput
    ) {
      return;
    }

    card.dataset.lfCartInit = '1';

    /* =====================================================
       STICKY → BODY
       ===================================================== */

    if (
      mobileStickyBar &&
      document.body &&
      mobileStickyBar.parentNode !== document.body
    ) {
      document.body.appendChild(
        mobileStickyBar
      );
    }

    /* =====================================================
       FORMAT PRIX
       ===================================================== */

    function money(value) {
      try {
        if (
          window.Shopify &&
          typeof window.Shopify.formatMoney ===
            'function'
        ) {
          const format =
            window.Shopify.money_format ||
            window.theme?.moneyFormat ||
            '{{amount_with_comma_separator}} €';

          return window.Shopify.formatMoney(
            Number(value || 0),
            format
          );
        }
      } catch (error) {}

      return (
        Number(value || 0) / 100
      )
        .toFixed(2)
        .replace('.', ',') + ' €';
    }

    /* =====================================================
       QUANTITÉ
       ===================================================== */

    function normalizeQuantity(value) {
      const parsed =
        parseInt(value, 10);

      if (
        Number.isNaN(parsed) ||
        parsed < 1
      ) {
        return 1;
      }

      return parsed;
    }

    function syncQuantityFromMain() {
      const value =
        normalizeQuantity(
          quantityInput.value
        );

      quantityInput.value =
        value;

      if (mobileStickyQuantity) {
        mobileStickyQuantity.value =
          value;
      }

      return value;
    }

    function syncQuantityFromSticky() {
      if (!mobileStickyQuantity) {
        return syncQuantityFromMain();
      }

      const value =
        normalizeQuantity(
          mobileStickyQuantity.value
        );

      mobileStickyQuantity.value =
        value;

      quantityInput.value =
        value;

      return value;
    }

    /* =====================================================
       STOCK / DISPONIBILITÉ
       ===================================================== */

    function updateStock(available) {
      if (!stock) return;

      const dot =
        stock.querySelector(
          '.lf-stock-dot'
        );

      const text =
        stock.querySelector(
          'span:last-child'
        );

      if (dot) {
        dot.classList.toggle(
          'out',
          !available
        );
      }

      if (text) {
        text.textContent =
          available
            ? 'En stock'
            : 'Actuellement indisponible';
      }
    }

    function updateButtons(available) {
      if (addButton) {
        addButton.disabled =
          !available;
      }

      if (buyButton) {
        buyButton.disabled =
          !available;
      }

      if (mobileStickyAdd) {
        mobileStickyAdd.disabled =
          !available;
      }
    }

    /* =====================================================
       CART TARGET
       ===================================================== */

    function getCartTarget() {
      const selectors = [
        'header a[href$="/cart"]',
        'header a[href*="/cart"]',
        '.header a[href$="/cart"]',
        '.header a[href*="/cart"]',
        '.site-header a[href$="/cart"]',
        '.site-header a[href*="/cart"]',
        '[data-cart-icon]',
        '#cart-icon-bubble',
        '.cart-count-bubble',
        '[data-cart-count]',
        '[data-cart-item-count]',
        'a[href$="/cart"]',
        'a[href*="/cart"]'
      ];

      for (
        const selector of selectors
      ) {
        const nodes =
          document.querySelectorAll(
            selector
          );

        for (
          const node of nodes
        ) {
          const rect =
            node.getBoundingClientRect();

          if (
            rect.width > 0 &&
            rect.height > 0
          ) {
            return node;
          }
        }
      }

      return null;
    }

    /* =====================================================
       ANIMATION PRODUIT → PANIER
       VERSION COMPACTE
       ===================================================== */

    function flyToCart() {
      const image =
        card.querySelector(
          '.lf-main-product-image'
        );

      if (
        !image ||
        !addButton
      ) {
        return;
      }

      const from =
        addButton.getBoundingClientRect();

      const startX =
        from.left +
        from.width / 2;

      const startY =
        from.top +
        from.height / 2;

      const clone =
        document.createElement('img');

      clone.className =
        'lf-fly-product';

      clone.src =
        image.currentSrc ||
        image.src;

      clone.alt = '';

      clone.style.left =
        startX - 21 + 'px';

      clone.style.top =
        startY - 21 + 'px';

      clone.style.width =
        '42px';

      clone.style.height =
        '42px';

      clone.style.objectFit =
        'cover';

      clone.style.transform =
        'translate3d(0,0,0) scale(.82)';

      clone.style.opacity =
        '1';

      clone.style.pointerEvents =
        'none';

      clone.style.zIndex =
        '99999';

      document.body.appendChild(
        clone
      );

      const trail = [];

      for (
        let i = 0;
        i < 3;
        i++
      ) {
        const dot =
          document.createElement(
            'span'
          );

        dot.className =
          'lf-add-flight';

        const size =
          5 - i;

        dot.style.width =
          size + 'px';

        dot.style.height =
          size + 'px';

        dot.style.left =
          startX -
          size / 2 +
          'px';

        dot.style.top =
          startY -
          size / 2 +
          'px';

        dot.style.animation =
          'none';

        dot.style.opacity =
          '0';

        dot.style.pointerEvents =
          'none';

        dot.style.zIndex =
          '99998';

        document.body.appendChild(
          dot
        );

        trail.push(dot);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {

          const target =
            getCartTarget();

          if (!target) {
            clone.remove();

            trail.forEach(
              item => item.remove()
            );

            return;
          }

          const to =
            target.getBoundingClientRect();

          const endX =
            to.left +
            to.width / 2;

          const endY =
            to.top +
            to.height / 2;

          const dx =
            endX - startX;

          const dy =
            endY - startY;

          const arcLift =
            Math.min(
              55,
              Math.max(
                25,
                Math.abs(dx) * 0.08 +
                Math.abs(dy) * 0.05
              )
            );

          clone.animate(
            [
              {
                transform:
                  'translate3d(0,0,0) scale(.82)',
                opacity: 1
              },
              {
                transform:
                  `translate3d(
                    ${dx * 0.28}px,
                    ${dy * 0.28 - arcLift}px,
                    0
                  ) scale(.68)`,
                opacity: .96
              },
              {
                transform:
                  `translate3d(
                    ${dx * 0.72}px,
                    ${dy * 0.72 - arcLift * 0.35}px,
                    0
                  ) scale(.42)`,
                opacity: .82
              },
              {
                transform:
                  `translate3d(
                    ${dx}px,
                    ${dy}px,
                    0
                  ) scale(.12)`,
                opacity: 0
              }
            ],
            {
              duration: 650,
              easing:
                'cubic-bezier(.22,.75,.28,1)',
              fill: 'forwards'
            }
          );

          trail.forEach(
            (dot, i) => {

              const t =
                .25 + i * .18;

              dot.animate(
                [
                  {
                    transform:
                      'translate3d(0,0,0) scale(.2)',
                    opacity: 0
                  },
                  {
                    transform:
                      `translate3d(
                        ${dx * t}px,
                        ${dy * t - arcLift * (1 - t)}px,
                        0
                      ) scale(.9)`,
                    opacity: .7
                  },
                  {
                    transform:
                      `translate3d(
                        ${dx * t}px,
                        ${dy * t}px,
                        0
                      ) scale(.1)`,
                    opacity: 0
                  }
                ],
                {
                  duration: 480,
                  delay:
                    80 + i * 55,
                  easing:
                    'ease-out',
                  fill:
                    'forwards'
                }
              );
            }
          );

          setTimeout(() => {

            if (
              typeof target.animate ===
              'function'
            ) {
              target.animate(
                [
                  {
                    transform:
                      'scale(1)'
                  },
                  {
                    transform:
                      'scale(1.10)'
                  },
                  {
                    transform:
                      'scale(.97)'
                  },
                  {
                    transform:
                      'scale(1.03)'
                  },
                  {
                    transform:
                      'scale(1)'
                  }
                ],
                {
                  duration: 360,
                  easing:
                    'cubic-bezier(.2,.9,.25,1)'
                }
              );
            }
          }, 560);
        });
      });

      setTimeout(() => {
        clone.remove();
      }, 850);

      setTimeout(() => {
        trail.forEach(
          item => item.remove()
        );
      }, 700);

      addButton.classList.remove(
        'lf-added-pulse'
      );

      void addButton.offsetWidth;

      addButton.classList.add(
        'lf-added-pulse'
      );
    }

    /* =====================================================
       COMPTEURS PANIER
       ===================================================== */

    function updateCounters(cart) {
      if (!cart) return;

      const count =
        Number(
          cart.item_count || 0
        );

      const total =
        Number(
          cart.total_price || 0
        );

      document
        .querySelectorAll(
          '.cart-count-bubble,' +
          '[data-cart-count],' +
          '[data-cart-item-count]'
        )
        .forEach(
          element => {

            element.textContent =
              count;

            element.classList.toggle(
              'hidden',
              count === 0
            );
          }
        );

      document
        .querySelectorAll(
          '[data-cart-total]'
        )
        .forEach(
          element => {
            element.textContent =
              money(total);
          }
        );

      if (mini) {

        const countElement =
          mini.querySelector(
            '[data-count]'
          );

        const totalElement =
          mini.querySelector(
            '[data-total]'
          );

        if (countElement) {
          countElement.textContent =
            count;
        }

        if (totalElement) {
          totalElement.textContent =
            money(total);
        }
      }

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            bubbles: true,
            detail: {
              cart: cart
            }
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true,
            detail: {
              cart: cart
            }
          }
        )
      );
    }

    /* =====================================================
       LECTURE DU PANIER
       ===================================================== */

    async function getCart() {

      const root =
        window.Shopify?.routes?.root ||
        '/';

      const response =
        await fetch(
          root +
          'cart.js?lf=' +
          Date.now(),
          {
            method: 'GET',
            credentials:
              'same-origin',
            headers: {
              Accept:
                'application/json'
            },
            cache:
              'no-store'
          }
        );

      if (!response.ok) {
        throw new Error(
          'Lecture du panier impossible'
        );
      }

      return response.json();
    }

    /* =====================================================
       VARIANTE
       ===================================================== */

    function getMainVariantOption() {
      if (!variantSelect) {
        return null;
      }

      return (
        variantSelect.options[
          variantSelect.selectedIndex
        ] || null
      );
    }

    function getStickyVariantOption() {
      if (!mobileStickyVariant) {
        return null;
      }

      return (
        mobileStickyVariant.options[
          mobileStickyVariant.selectedIndex
        ] || null
      );
    }

    function updateVariantFromOption(
      option
    ) {
      if (!option) return;

      const id =
        option.value;

      const available =
        option.dataset.available ===
        'true';

      const variantPrice =
        option.dataset.price ||
        '';

      const image =
        option.dataset.image ||
        '';

      variantInput.value =
        id;

      if (
        price &&
        variantPrice
      ) {
        price.textContent =
          variantPrice;
      }

      if (
        addPrice &&
        variantPrice
      ) {
        addPrice.textContent =
          variantPrice;
      }

      if (
        mobileStickyPrice &&
        variantPrice
      ) {
        mobileStickyPrice.textContent =
          variantPrice;
      }

      if (
        image &&
        mainImage
      ) {
        mainImage.src =
          image;
      }

      updateStock(
        available
      );

      updateButtons(
        available
      );

      if (
        mobileStickyVariant &&
        mobileStickyVariant.value !==
          id
      ) {
        mobileStickyVariant.value =
          id;
      }

      if (
        variantSelect &&
        variantSelect.value !==
          id
      ) {
        variantSelect.value =
          id;
      }
    }

    function updateVariant() {

      const option =
        getMainVariantOption();

      updateVariantFromOption(
        option
      );
    }

    /* =====================================================
       ÉCOUTE VARIANTE PRINCIPALE
       ===================================================== */

    if (variantSelect) {

      variantSelect.addEventListener(
        'change',
        function () {
          updateVariant();
        }
      );
    }

    /* =====================================================
       ÉCOUTE VARIANTE STICKY
       ===================================================== */

    if (mobileStickyVariant) {

      mobileStickyVariant.addEventListener(
        'change',
        function () {

          const option =
            getStickyVariantOption();

          if (!option) {
            return;
          }

          updateVariantFromOption(
            option
          );

          if (
            variantSelect
          ) {
            variantSelect.value =
              mobileStickyVariant.value;
          }
        }
      );
    }

    /* =====================================================
       QUANTITÉ PRINCIPALE
       ===================================================== */

    card
      .querySelectorAll(
        '.lf-qty'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            function () {

              const change =
                parseInt(
                  button.dataset.q,
                  10
                ) || 0;

              const current =
                normalizeQuantity(
                  quantityInput.value
                );

              quantityInput.value =
                Math.max(
                  1,
                  current +
                    change
                );

              syncQuantityFromMain();

              quantityInput.dispatchEvent(
                new Event(
                  'change',
                  {
                    bubbles: true
                  }
                )
              );
            }
          );
        }
      );

    quantityInput.addEventListener(
      'input',
      function () {
        syncQuantityFromMain();
      }
    );

    quantityInput.addEventListener(
      'change',
      function () {
        syncQuantityFromMain();
      }
    );

    /* =====================================================
       QUANTITÉ STICKY
       ===================================================== */

    if (
      mobileStickyBar &&
      mobileStickyQuantity
    ) {

      mobileStickyBar
        .querySelectorAll(
          '[data-lf-sticky-qty]'
        )
        .forEach(
          button => {

            button.addEventListener(
              'click',
              function () {

                const change =
                  parseInt(
                    button.dataset
                      .lfStickyQty,
                    10
                  ) || 0;

                const current =
                  normalizeQuantity(
                    mobileStickyQuantity
                      .value
                  );

                const next =
                  Math.max(
                    1,
                    current +
                      change
                  );

                mobileStickyQuantity.value =
                  next;

                quantityInput.value =
                  next;

                quantityInput.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles: true
                    }
                  )
                );
              }
            );
          }
        );

      mobileStickyQuantity.addEventListener(
        'input',
        function () {
          syncQuantityFromSticky();
        }
      );

      mobileStickyQuantity.addEventListener(
        'change',
        function () {
          syncQuantityFromSticky();
        }
      );
    }

    /* =====================================================
       AJOUT PRODUIT
       ===================================================== */

    async function addProduct() {

      const variantId =
        String(
          variantInput.value ||
          ''
        ).trim();

      const quantity =
        Math.max(
          1,
          parseInt(
            quantityInput.value,
            10
          ) || 1
        );

      if (!variantId) {
        throw new Error(
          'ID variante manquant'
        );
      }

      const root =
        window.Shopify?.routes?.root ||
        '/';

      const response =
        await fetch(
          root +
          'cart/add.js?lf=' +
          Date.now(),
          {
            method: 'POST',
            credentials:
              'same-origin',

            headers: {
              Accept:
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest',

              'Content-Type':
                'application/x-www-form-urlencoded; charset=UTF-8'
            },

            body:
              new URLSearchParams({
                id:
                  variantId,

                quantity:
                  String(
                    quantity
                  )
              })
          }
        );

      let result =
        null;

      try {
        result =
          await response.json();
      } catch (error) {}

      if (!response.ok) {

        throw new Error(
          result &&
          result.description
            ? result.description
            : 'Le produit n’a pas pu être ajouté au panier'
        );
      }

      return result;
    }

    /* =====================================================
       OUVERTURE MINI PANIER
       ===================================================== */

    function openMiniCart(
      cart
    ) {

      if (!mini) {
        return;
      }

      const countElement =
        mini.querySelector(
          '[data-count]'
        );

      const totalElement =
        mini.querySelector(
          '[data-total]'
        );

      if (countElement) {
        countElement.textContent =
          cart.item_count;
      }

      if (totalElement) {
        totalElement.textContent =
          money(
            cart.total_price
          );
      }

      mini.classList.remove(
        'is-visible'
      );

      void mini.offsetWidth;

      mini.classList.add(
        'is-visible'
      );

      mini.setAttribute(
        'aria-hidden',
        'false'
      );
    }

    /* =====================================================
       AJOUT AU PANIER
       ===================================================== */

    async function handleAdd(
      sourceButton
    ) {

      if (
        addButton.disabled ||
        (
          sourceButton &&
          sourceButton.disabled
        )
      ) {
        return;
      }

      const original =
        addButton.innerHTML;

      const addButtonText =
        addPrice
          ? addPrice.textContent
          : '';

      addButton.disabled =
        true;

      if (mobileStickyAdd) {
        mobileStickyAdd.disabled =
          true;
      }

      addButton.innerHTML =
        '<span>✓ AJOUT AU PANIER...</span>' +
        '<strong>' +
        addButtonText +
        '</strong>';

      if (
        mobileStickyAdd
      ) {
        mobileStickyAdd.innerHTML =
          '<span>✓ AJOUT...</span>' +
          '<strong>' +
          (
            mobileStickyPrice
              ? mobileStickyPrice.textContent
              : addButtonText
          ) +
          '</strong>';
      }

      try {

        await addProduct();

        /* Animation */
        flyToCart();

        /* Récupération panier */
        const cart =
          await getCart();

        /* Mise à jour compteurs */
        updateCounters(
          cart
        );

        /* Mini-panier */
        openMiniCart(
          cart
        );

        /* Feedback principal */
        addButton.innerHTML =
          '<span>✓ AJOUTÉ AU PANIER</span>' +
          '<strong>' +
          addButtonText +
          '</strong>';

        /* Feedback sticky */
        if (
          mobileStickyAdd
        ) {
          mobileStickyAdd.innerHTML =
            '<span>✓ AJOUTÉ</span>' +
            '<strong>' +
            (
              mobileStickyPrice
                ? mobileStickyPrice.textContent
                : addButtonText
            ) +
            '</strong>';
        }

        setTimeout(
          () => {

            addButton.classList.remove(
              'lf-added-pulse'
            );

            addButton.innerHTML =
              original;

            const currentOption =
              getMainVariantOption();

            const available =
              currentOption
                ? currentOption.dataset.available ===
                  'true'
                : true;

            addButton.disabled =
              !available;

            if (
              mobileStickyAdd
            ) {
              mobileStickyAdd.innerHTML =
                '<span>🛒 AJOUTER AU PANIER</span>' +
                '<strong>' +
                (
                  mobileStickyPrice
                    ? mobileStickyPrice.textContent
                    : addButtonText
                ) +
                '</strong>';

              mobileStickyAdd.disabled =
                !available;
            }

          },
          2400
        );

      } catch (error) {

        console.error(
          'Luminaire France - panier:',
          error
        );

        addButton.innerHTML =
          '<span>⚠ RÉESSAYER</span>' +
          '<strong>' +
          addButtonText +
          '</strong>';

        if (
          mobileStickyAdd
        ) {
          mobileStickyAdd.innerHTML =
            '<span>⚠ RÉESSAYER</span>' +
            '<strong>' +
            (
              mobileStickyPrice
                ? mobileStickyPrice.textContent
                : addButtonText
            ) +
            '</strong>';
        }

        setTimeout(
          () => {

            addButton.innerHTML =
              original;

            const currentOption =
              getMainVariantOption();

            const available =
              currentOption
                ? currentOption.dataset.available ===
                  'true'
                : true;

            addButton.disabled =
              !available;

            if (
              mobileStickyAdd
            ) {
              mobileStickyAdd.innerHTML =
                '<span>🛒 AJOUTER AU PANIER</span>' +
                '<strong>' +
                (
                  mobileStickyPrice
                    ? mobileStickyPrice.textContent
                    : addButtonText
                ) +
                '</strong>';

              mobileStickyAdd.disabled =
                !available;
            }

          },
          1800
        );
      }
    }

    /* =====================================================
       CTA PRINCIPAL
       ===================================================== */

    addButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        handleAdd(
          addButton
        );
      }
    );

    /* =====================================================
       CTA STICKY
       ===================================================== */

    if (
      mobileStickyAdd
    ) {

      mobileStickyAdd.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          if (
            mobileStickyQuantity
          ) {
            syncQuantityFromSticky();
          }

          if (
            mobileStickyVariant
          ) {
            const option =
              getStickyVariantOption();

            if (option) {
              updateVariantFromOption(
                option
              );
            }
          }

          handleAdd(
            mobileStickyAdd
          );
        }
      );

      /* =====================================================
         AFFICHAGE STICKY
         ===================================================== */

      function setStickyVisible(
        visible
      ) {

        const target =
          mobileStickyBar ||
          mobileStickyAdd;

        if (!target) {
          return;
        }

        target.classList.toggle(
          'is-visible',
          visible
        );

        target.setAttribute(
          'aria-hidden',
          visible
            ? 'false'
            : 'true'
        );
      }

      if (
        'IntersectionObserver' in
        window
      ) {

        const stickyObserver =
          new IntersectionObserver(
            entries => {

              if (
                window.innerWidth >
                749
              ) {
                setStickyVisible(
                  false
                );

                return;
              }

              const entry =
                entries[0];

              setStickyVisible(
                !entry.isIntersecting
              );
            },
            {
              threshold: 0.05,
              root: null
            }
          );

        stickyObserver.observe(
          addButton
        );

      } else {

        function fallbackSticky() {

          if (
            window.innerWidth >
            749
          ) {
            setStickyVisible(
              false
            );

            return;
          }

          const rect =
            addButton.getBoundingClientRect();

          const visible =
            rect.bottom > 0 &&
            rect.top <
              window.innerHeight;

          setStickyVisible(
            !visible
          );
        }

        window.addEventListener(
          'scroll',
          fallbackSticky,
          {
            passive: true
          }
        );

        window.addEventListener(
          'resize',
          fallbackSticky
        );

        fallbackSticky();
      }
    }

    /* =====================================================
       ACHETER MAINTENANT
       ===================================================== */

    if (buyButton) {

      buyButton.addEventListener(
        'click',
        async function (event) {

          event.preventDefault();
          event.stopPropagation();

          if (
            buyButton.disabled
          ) {
            return;
          }

          buyButton.disabled =
            true;

          try {

            await addProduct();

            window.location.href =
              '/checkout';

          } catch (error) {

            console.error(
              'Luminaire France - achat immédiat:',
              error
            );

            buyButton.disabled =
              false;

            form.submit();
          }
        }
      );
    }

    /* =====================================================
       FERMETURE MINI PANIER
       ===================================================== */

    if (mini) {

      mini
        .querySelectorAll(
          '[data-close]'
        )
        .forEach(
          button => {

            button.addEventListener(
              'click',
              function (event) {

                event.preventDefault();

                mini.classList.remove(
                  'is-visible'
                );

                mini.setAttribute(
                  'aria-hidden',
                  'true'
                );
              }
            );
          }
        );

      const overlay =
        mini.querySelector(
          '.lf-mobile-mini-cart__overlay'
        );

      if (overlay) {

        overlay.addEventListener(
          'click',
          function () {

            mini.classList.remove(
              'is-visible'
            );

            mini.setAttribute(
              'aria-hidden',
              'true'
            );
          }
        );
      }
    }

    /* =====================================================
       ESCAPE
       ===================================================== */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          mini &&
          mini.classList.contains(
            'is-visible'
          )
        ) {

          mini.classList.remove(
            'is-visible'
          );

          mini.setAttribute(
            'aria-hidden',
            'true'
          );
        }
      }
    );

    /* =====================================================
       INITIALISATION VARIANTE
       ===================================================== */

    if (variantSelect) {
      updateVariant();
    } else {

      if (
        mobileStickyPrice &&
        addPrice
      ) {
        mobileStickyPrice.textContent =
          addPrice.textContent;
      }
    }

    /* =====================================================
       INITIALISATION QUANTITÉ
       ===================================================== */

    syncQuantityFromMain();

    /* =====================================================
       SYNCHRONISATION STICKY AU CHARGEMENT
       ===================================================== */

    if (
      mobileStickyVariant &&
      variantSelect
    ) {
      mobileStickyVariant.value =
        variantSelect.value;
    }

    if (
      mobileStickyPrice &&
      addPrice
    ) {
      mobileStickyPrice.textContent =
        addPrice.textContent;
    }
  }

  /* =======================================================
     INITIALISATION DE TOUTES LES PRODUCT CARDS
     ======================================================= */

  function initAllProductCards() {

    document
      .querySelectorAll(
        '.lf-product-card-premium'
      )
      .forEach(
        initProductCart
      );
  }

  /* =======================================================
     DOM READY
     ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllProductCards
    );

  } else {

    initAllProductCards();
  }

  /* =======================================================
     SHOPIFY SECTION RELOAD
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    initAllProductCards
  );

})();